// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"64f1dbed","605":"80e4e8fa","809":"62452d41","981":"fbc2c799"}[chunkId] + ".chunk.js";
};